<template>
	<div class="overlay">
		<slot />
	</div>
</template>

<script>
export default {
	name: 'Overlay'
}
</script>

<style lang="scss" scoped>
.overlay {
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	min-height: 100%;
	z-index: 1000;
}
</style>
